import {Column, Entity, JoinColumn, OneToMany, OneToOne} from "typeorm";
import type {Relation} from "typeorm";
import {Min} from "class-validator";
import {BaseEntity} from "@/modules/base/entity";
import {Player} from "@/modules/team/entity";
import {TransferOffer} from "@/modules/transfer-market/entity/TransferOffer";

@Entity()
export class TransferListing extends BaseEntity {
  @OneToOne(() => Player)
  @JoinColumn()
  player: Relation<Player>;

  @OneToMany(() => TransferOffer, r => r.listing)
  offers: Relation<TransferOffer[]>;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  price: number;
}
